import type { Hex } from '@metamask/utils';

import { CHAIN_IDS } from '../constants.js';
import type { TransactionControllerMessenger } from '../TransactionController.js';
import type { TransactionMeta } from '../types.js';
import { OracleLayer1GasFeeFlow } from './OracleLayer1GasFeeFlow.js';

const SCROLL_CHAIN_IDS: Hex[] = [CHAIN_IDS.SCROLL, CHAIN_IDS.SCROLL_SEPOLIA];

// BlockExplorer link: https://scrollscan.com/address/0x5300000000000000000000000000000000000002#code
const SCROLL_GAS_PRICE_ORACLE_ADDRESS =
  '0x5300000000000000000000000000000000000002' as Hex;

/**
 * Scroll layer 1 gas fee flow that obtains gas fee estimate using an oracle contract.
 */
export class ScrollLayer1GasFeeFlow extends OracleLayer1GasFeeFlow {
  protected override getOracleAddressForChain(_chainId: Hex): Hex {
    return SCROLL_GAS_PRICE_ORACLE_ADDRESS;
  }

  protected override shouldSignTransaction(): boolean {
    return true;
  }

  async matchesTransaction({
    transactionMeta,
  }: {
    transactionMeta: TransactionMeta;
    messenger: TransactionControllerMessenger;
  }): Promise<boolean> {
    return SCROLL_CHAIN_IDS.includes(transactionMeta.chainId);
  }
}
